import { type RefObject, useEffect } from 'react';

import { type GenerateStatus } from '@/shared/features/ai-quiz-generation/types';

/**
 * 재생성 시 결과 섹션으로 자동 스크롤하는 hook
 *
 * 재생성이 시작되면:
 * 1. bodyRef를 결과 섹션 상단으로 스크롤
 * 2. resultRef 내부를 최상단으로 스크롤
 *
 * @param generateStatus - 생성 상태
 * @param resultRef - 결과 섹션 ref
 * @param bodyRef - 모달 body ref
 */
export const useResultSectionScroll = (
  generateStatus: GenerateStatus,
  resultRef: RefObject<HTMLDivElement>,
  bodyRef: RefObject<HTMLDivElement>,
) => {
  useEffect(() => {
    if (!resultRef.current || !bodyRef.current) return;
    if (generateStatus !== 'regenerating') return;

    const offsetTop = resultRef.current.offsetTop;

    bodyRef.current.scrollTo({
      behavior: 'smooth',
      top: offsetTop,
    });

    resultRef.current.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }, [generateStatus, resultRef, bodyRef]);
};
